var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#039BE5",
    cx: 17.28,
    cy: 17.28,
    r: 17.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.907 16.906 16.66-6.424c.774-.28 1.45.188 1.199 1.358l.001-.002-2.836 13.365c-.21.947-.774 1.178-1.561.731l-4.32-3.183-2.084 2.007c-.23.23-.425.425-.871.425l.306-4.397 8.007-7.233c.348-.306-.078-.48-.537-.174l-9.895 6.23-4.265-1.331c-.926-.294-.946-.926.196-1.372z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0772deb65877ffb3205683d1807cc031.svg";
export { ForwardRef as ReactComponent };